import React from "react";
import { CsvToHtmlTable } from "react-csv-to-table";

export interface CSVFileViewerDialogProps {
	//The string representation of the csv file to be displayed.
	file: string;
}

/**
 * This component is used for displaying a csv file in a
 * @param props
 */
export const CSVFileViewer = (props: CSVFileViewerDialogProps) => {
	return (
		<div>
			<CsvToHtmlTable data={props.file} csvDelimiter="," tableClassName="table table-striped table-hover" />
		</div>
	);
};
